import React from 'react';
import DisplayView from 'main/components/show/cuesheet.displayView/displayView.jsx';
import FullScreenCuesheetActions from 'flux/actions/cuesheet.fullscreen/FullScreenCuesheetActions';
import TeamViewActions from 'flux/actions/TeamViewActions';
import EventViewActions from 'flux/actions/EventViewActions';
import EventShowListActions from 'flux/actions/EventShowListActions';
import VersionNumberActions from 'flux/actions/VersionNumberActions';
import IntercomActions from 'flux/actions/IntercomActions';
import AlertBarAwareContainer from 'main/components/show/cuesheet/alertBarAwareContainer';

// NOTE THIS FILE HAS MANY PROP TYPE VIOLATIONS
// AND ALL ARE DISABLED BY THE COMMENT BELOW.
/* eslint-disable react/prop-types */

class DisplayViewPage extends React.Component {
  componentDidMount() {
    IntercomActions.hideChat(true);
    const { params } = this.props;
    const { teamId, eventId } = params;

    TeamViewActions.populate(teamId);
    EventViewActions.populate(teamId, eventId);
    EventShowListActions.populate(teamId, eventId);
    VersionNumberActions.hide();
    _overrideContainerClasses(true);
  }

  componentWillUnmount() {
    IntercomActions.hideChat(false);
    VersionNumberActions.show();
    _overrideContainerClasses();
  }

  render() {
    const { params } = this.props;

    return (
      <AlertBarAwareContainer className="display-view-wrapper">
        <DisplayView
          {...params}
          onToggleFullScreenMode={() =>
            FullScreenCuesheetActions.toggleFullScreen()
          }
        />
      </AlertBarAwareContainer>
    );
  }
}

function _overrideContainerClasses(override) {
  if (override) {
    document.body.style.overflow = 'unset';
    document.body.style.background = '#1e2131';
  } else {
    document.body.style = {};
  }
}

export default DisplayViewPage;
